const model = {
  retrived: false,
  loading: true,
  data: {},
  errors: {}
}

export default model;
